/* It's a React component. */
import React from "react"
import "./TrashCan.css"

interface Props {
    clickCallback?: Function | any
    color: string
}

function TrashCan(props: Props) {

    return (
        <div className="TrashCan">
            <section>
                <span className="trash" onClick={props.clickCallback ? () => props.clickCallback() : () => null} style={{ background: props.color }}>
                    <span style={{ background: props.color }}></span>
                </span>
            </section>
        </div>
    )
}

export default TrashCan